// healthtrio namespace
if (ht == undefined || ht == null) {
  var ht = {};
  ht.log = function () {};
}
//smartshell
ht.smartuishell = ht.smartuishell || false;
